import React from "react";
import Switch from "react-switch";
import { connect } from "react-redux";
let checked = false;
class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
  }
  handleClick = (e, data) => {
    if (data == "and") {
      this.setState({ checked: false });
    } else {
      this.setState({ checked: true });
    }
    this.toggleReduxChange();
  };

  toggleReduxChange() {
    let selectedToggle = this.state.checked ? "AND" : "OR";
    let type =
      this.props.type == "Rule"
        ? "CUST_ADD_RULE_LEVEL_TOGGLE_SEGMENT"
        : "CUST_ADD_GROUP_LEVEL_TOGGLE_SEGMENT";
    this.props.dispatch({
      type: type,
      payload: selectedToggle,
      selectedIndex: this.props.selectedIndex,
      selectedRule: this.props.selectedRule
    });
    this.props.dispatch({ type: "CUST_Add_SEGMENT" });
  }

  render() {
    let selectedIndex = this.props.selectedIndex;
    let selectedRule = this.props.selectedRule;
    if (selectedRule !== "" && selectedIndex !== "no_index") {
      if (
        this.props.cust_ruleLeveltoggleSegment.length > 0 &&
        this.props.cust_ruleLeveltoggleSegment[selectedIndex] !== undefined &&
        this.props.cust_ruleLeveltoggleSegment[selectedIndex][selectedRule] !==
          undefined
      ) {
        checked =
          this.props.cust_ruleLeveltoggleSegment[selectedIndex][selectedRule] ===
          "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else if (selectedIndex !== "no_index") {
      if (
        this.props.cust_groupLeveltoggleSegment.length > 0 &&
        this.props.cust_groupLeveltoggleSegment[0] !== undefined &&
        this.props.cust_groupLeveltoggleSegment[0][selectedIndex][selectedIndex] !==
          undefined
      ) {
        checked =
          this.props.cust_groupLeveltoggleSegment[0][selectedIndex] === "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else {
      this.state = { checked: checked };
    }
    return (
      <React.Fragment>
        <span
          className={this.state.checked ? "andorbtn btnor" : "andorbtn btnand"}
          onClick={e => this.handleClick(e, "and")}
        >
          and
        </span>
        <span
          className={this.state.checked ? "andorbtn btnand" : " andorbtn btnor"}
          onClick={e => this.handleClick(e, "or")}
        >
          or
        </span>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  cust_countSegment: state.cust_countSegment,
  cust_tillSqlSelectionArrSegment: state.cust_tillSqlSelectionArrSegment,
  cust_afterSqlSelectionArrSegment: state.cust_afterSqlSelectionArrSegment,
  cust_groupLeveltoggleSegment: state.cust_groupLeveltoggleSegment,
  cust_ruleLeveltoggleSegment: state.cust_ruleLeveltoggleSegment,
  cust_queryCountSegment: state.cust_queryCountSegment
});

export default connect(mapStateToProps)(ToggleButton);



// WEBPACK FOOTER //
// ./src/views/Audiences/CSegmentQueryBuilder/ToggleButton.jsx